module.exports = __webpack_public_path__ + "img/1.21b0d79d.jpeg";